import { hasAccessBasedOnArea } from "@/components/UserAreaBoundary/user-area-boundary.utils";
import { useAppSelector } from "@/store";
import type { UserAreaName } from "@/types/user.types";

type Options = {
    areas: UserAreaName[];
    allowDeveloperMode?: boolean;
};

export const useUserAreaBoundary = (options: Options) => {
    const { areas, allowDeveloperMode = false } = options;

    const userAreas = useAppSelector((state) => state.user.areas);
    const developerMode = useAppSelector((state) => state.user.developerMode);

    const isAllowed = hasAccessBasedOnArea({
        userAreas,
        allowUserAreas: areas,
        developerMode,
        allowDeveloperMode,
    });

    return { isAllowed };
};
